import moment from 'moment';
export default class Duration {
    constructor(value) {
        this.$duration = moment.duration(value);
    }
    static fromDays(days) {
        return new Duration(moment.duration(days, 'days'));
    }
    static fromHours(hours) {
        return new Duration(moment.duration(hours, 'hours'));
    }
    static fromMilliseconds(milliseconds) {
        return new Duration(moment.duration(milliseconds, 'milliseconds'));
    }
    static fromMinutes(minutes) {
        return new Duration(moment.duration(minutes, 'minutes'));
    }
    static fromMonths(months) {
        return new Duration(moment.duration(months, 'months'));
    }
    static fromRange(start, end) {
        return new Duration(moment.duration({ from: start, to: end }));
    }
    static fromSeconds(seconds) {
        return new Duration(moment.duration(seconds, 'seconds'));
    }
    static fromWeeks(weeks) {
        return new Duration(moment.duration(weeks, 'weeks'));
    }
    static fromYears(years) {
        return new Duration(moment.duration(years, 'years'));
    }
    get totalDays() {
        return this.$duration.asDays();
    }
    get totalHours() {
        return this.$duration.asHours();
    }
    get totalMilliseconds() {
        return this.$duration.asMilliseconds();
    }
    get totalMinutes() {
        return this.$duration.asMinutes();
    }
    get totalMonths() {
        return this.$duration.asMonths();
    }
    get totalSeconds() {
        return this.$duration.asSeconds();
    }
    get totalWeeks() {
        return this.$duration.asWeeks();
    }
    get totalYears() {
        return this.$duration.asYears();
    }
    addDays(days) {
        return new Duration(this.$duration.add(days, 'days'));
    }
    addHours(hours) {
        return new Duration(this.$duration.add(hours, 'hours'));
    }
    addMilliseconds(days) {
        return new Duration(this.$duration.add(days, 'milliseconds'));
    }
    addMinutes(minutes) {
        return new Duration(this.$duration.add(minutes, 'minutes'));
    }
    addMonths(days) {
        return new Duration(this.$duration.add(days, 'months'));
    }
    addSeconds(days) {
        return new Duration(this.$duration.add(days, 'seconds'));
    }
    addWeeks(days) {
        return new Duration(this.$duration.add(days, 'weeks'));
    }
    addYears(days) {
        return new Duration(this.$duration.add(days, 'years'));
    }
    diff(other) {
        return new Duration(this.$duration.subtract(other.$duration));
    }
}
//# sourceMappingURL=Duration.js.map